export default __webpack_public_path__ + "assets/icon-history.5aefc42a.webp";